import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouteChanged } from '@completion/actions';
import { Store } from '@ngrx/store';

import { CpState } from '../store/reducers/cp';
@Injectable({
  providedIn: 'root',
})
export class RouteParamsResolverService {
  constructor(private readonly store: Store<CpState>) {}

  resolve(route: ActivatedRouteSnapshot) {
    const cpIdParam = route.paramMap.get('id');
    const cpId = cpIdParam ? Number(cpIdParam) : null;

    const mcpIdParam = route.paramMap.get('mcpId');
    const mcpId = mcpIdParam ? Number(mcpIdParam) : null;

    const csIdParam = route.paramMap.get('csId');
    const csId = csIdParam ? Number(csIdParam) : null;

    this.store.dispatch(new RouteChanged(cpId, mcpId, csId));

    return null;
  }
}
